import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Project1 from "./pages/Project1";
import Project2 from "./pages/Project2";
import Project3 from "./pages/Project3";

import './App.css';



function App() {
  return (
    <Router>
      <div className="stars">
        <Switch>
          <Route exact path="/" component={Project1} />
          <Route exact path="/project2" component={Project2} />
          <Route exact path="/project3" component={Project3} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
